import {
  AMENITY_SPACES_CATEGORY,
  SUPPORT_SPACES_CATEGORY,
  CUSTOM_AMENITY_SPACE_COLORS,
  CUSTOM_MEETING_SPACE_COLORS,
  CUSTOM_WORKSPACE_COLORS,
  INDIVIDUAL_WORKSPACES_CATEGORY,
  SPACE_NAME_MAP,
  CUSTOM_SUPPORT_SPACE_COLORS,
  MEETING_SPACES_CATEGORY,
} from 'spw-constants';
import { IProjectColors } from 'spw-redux/modules/projects/types';

const {
  INDIVIDUAL_WORKSPACES,
  PRIVATE_OFFICES,
  MEETING_SPACES,
  AMENITY_SPACES,
  SUPPORT_SPACES,
} = SPACE_NAME_MAP;

export const spaceFactorMap = (
  projectColors: IProjectColors
): Record<
  string,
  {
    title: string;
    longTitle?: string;
    defaultCategory?: string;
    color: any;
  }
> => ({
  [INDIVIDUAL_WORKSPACES.WORKSTATION]: {
    title: 'Workstation',
    defaultCategory: INDIVIDUAL_WORKSPACES_CATEGORY,
    color:
      projectColors[CUSTOM_WORKSPACE_COLORS][1] ||
      projectColors[INDIVIDUAL_WORKSPACES_CATEGORY],
  },
  [INDIVIDUAL_WORKSPACES.HOTEL_DESK]: {
    title: 'Hotel Desk',
    defaultCategory: INDIVIDUAL_WORKSPACES_CATEGORY,
    color:
      projectColors[CUSTOM_WORKSPACE_COLORS][0] ||
      projectColors[INDIVIDUAL_WORKSPACES_CATEGORY],
  },
  [PRIVATE_OFFICES.PRIVATE_OFFICE]: {
    title: 'Private Office',
    defaultCategory: INDIVIDUAL_WORKSPACES_CATEGORY,
    color:
      projectColors[CUSTOM_WORKSPACE_COLORS][4] ||
      projectColors[INDIVIDUAL_WORKSPACES_CATEGORY],
  },
  [PRIVATE_OFFICES.SHARED_PRIVATE_OFFICE]: {
    title: 'Shared Private Office',
    defaultCategory: INDIVIDUAL_WORKSPACES_CATEGORY,
    color:
      projectColors[CUSTOM_WORKSPACE_COLORS][6] ||
      projectColors[INDIVIDUAL_WORKSPACES_CATEGORY],
  },
  [PRIVATE_OFFICES.EXECUTIVE_PRIVATE_OFFICE]: {
    title: 'Executive Private Office',
    defaultCategory: INDIVIDUAL_WORKSPACES_CATEGORY,
    color:
      projectColors[CUSTOM_WORKSPACE_COLORS][5] ||
      projectColors[INDIVIDUAL_WORKSPACES_CATEGORY],
  },
  [MEETING_SPACES.HUDDLE_ROOM]: {
    title: 'Huddle Room',
    longTitle: 'Huddle Room (2-4 seats)',
    defaultCategory: MEETING_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_MEETING_SPACE_COLORS][1] ||
      projectColors[MEETING_SPACES_CATEGORY],
  },
  [MEETING_SPACES.PHONE_ROOM]: {
    title: 'Phone Room',
    longTitle: 'Phone Room (1-2 seats)',
    defaultCategory: MEETING_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_MEETING_SPACE_COLORS][3] ||
      projectColors[MEETING_SPACES_CATEGORY],
  },
  [MEETING_SPACES.SMALL_CONFERENCE_ROOM]: {
    title: 'Small Conference Room',
    longTitle: 'Small Conference Room (4-6 seats)',
    defaultCategory: MEETING_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_MEETING_SPACE_COLORS][4] ||
      projectColors[MEETING_SPACES_CATEGORY],
  },
  [MEETING_SPACES.MEDIUM_CONFERENCE_ROOM]: {
    title: 'Medium Conference Room',
    longTitle: 'Medium Conference Room (7-10 seats)',
    defaultCategory: MEETING_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_MEETING_SPACE_COLORS][7] ||
      projectColors[MEETING_SPACES_CATEGORY],
  },
  [MEETING_SPACES.LARGE_CONFERENCE_ROOM]: {
    title: 'Large Conference Room',
    longTitle: 'Large Conference Room (11-15 seats)',
    defaultCategory: MEETING_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_MEETING_SPACE_COLORS][9] ||
      projectColors[MEETING_SPACES_CATEGORY],
  },
  [MEETING_SPACES.X_LARGE_CONFERENCE_ROOM]: {
    title: 'X Large Conference Room',
    longTitle: 'X Large Conference Room (16+ seats)',
    defaultCategory: MEETING_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_MEETING_SPACE_COLORS][8] ||
      projectColors[MEETING_SPACES_CATEGORY],
  },
  [MEETING_SPACES.TRAINING_ROOM]: {
    title: 'Training Room',
    defaultCategory: MEETING_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_MEETING_SPACE_COLORS][6] ||
      projectColors[MEETING_SPACES_CATEGORY],
  },
  [MEETING_SPACES.MULTI_PURPOSE]: {
    title: 'Multi-Purpose All Hands',
    defaultCategory: MEETING_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_MEETING_SPACE_COLORS][2] ||
      projectColors[MEETING_SPACES_CATEGORY],
  },
  [MEETING_SPACES.OPEN_COLLABORATIVE_SPACE]: {
    title: 'Open Collaborative Space',
    defaultCategory: MEETING_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_MEETING_SPACE_COLORS][0] ||
      projectColors[MEETING_SPACES_CATEGORY],
  },
  [AMENITY_SPACES.BREAK_ROOM]: {
    title: 'Break Room',
    defaultCategory: AMENITY_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_AMENITY_SPACE_COLORS][0] ||
      projectColors[AMENITY_SPACES_CATEGORY],
  },
  [AMENITY_SPACES.CAFE]: {
    title: 'Cafe',
    defaultCategory: AMENITY_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_AMENITY_SPACE_COLORS][1] ||
      projectColors[AMENITY_SPACES_CATEGORY],
  },
  [AMENITY_SPACES.FITNESS_ROOM]: {
    title: 'Fitness Room',
    defaultCategory: AMENITY_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_AMENITY_SPACE_COLORS][2] ||
      projectColors[AMENITY_SPACES_CATEGORY],
  },
  [AMENITY_SPACES.GAME_ROOM]: {
    title: 'Game Room',
    defaultCategory: AMENITY_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_AMENITY_SPACE_COLORS][3] ||
      projectColors[AMENITY_SPACES_CATEGORY],
  },
  [AMENITY_SPACES.LIBRARY]: {
    title: 'Library',
    defaultCategory: AMENITY_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_AMENITY_SPACE_COLORS][4] ||
      projectColors[AMENITY_SPACES_CATEGORY],
  },
  [AMENITY_SPACES.MEDITATION_ROOM]: {
    title: 'Meditation Room',
    defaultCategory: AMENITY_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_AMENITY_SPACE_COLORS][5] ||
      projectColors[AMENITY_SPACES_CATEGORY],
  },
  [AMENITY_SPACES.MOTHERS_ROOM]: {
    title: "Mother's Room",
    defaultCategory: AMENITY_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_AMENITY_SPACE_COLORS][6] ||
      projectColors[AMENITY_SPACES_CATEGORY],
  },
  [AMENITY_SPACES.PANTRY]: {
    title: 'Pantry',
    defaultCategory: AMENITY_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_AMENITY_SPACE_COLORS][7] ||
      projectColors[AMENITY_SPACES_CATEGORY],
  },
  [AMENITY_SPACES.WELLNESS_ROOM]: {
    title: 'Wellness Room',
    defaultCategory: AMENITY_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_AMENITY_SPACE_COLORS][8] ||
      projectColors[AMENITY_SPACES_CATEGORY],
  },
  [SUPPORT_SPACES.ADA_BATHROOM]: {
    title: 'ADA Bathroom',
    defaultCategory: SUPPORT_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_SUPPORT_SPACE_COLORS][0] ||
      projectColors[SUPPORT_SPACES_CATEGORY],
  },
  [SUPPORT_SPACES.COAT_CLOSET]: {
    title: 'Coat Closet',
    defaultCategory: SUPPORT_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_SUPPORT_SPACE_COLORS][1] ||
      projectColors[SUPPORT_SPACES_CATEGORY],
  },
  [SUPPORT_SPACES.COPY_PRINT_ROOM]: {
    title: 'Copy/Print Room',
    defaultCategory: SUPPORT_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_SUPPORT_SPACE_COLORS][2] ||
      projectColors[SUPPORT_SPACES_CATEGORY],
  },
  [SUPPORT_SPACES.IDF]: {
    title: 'IDF',
    defaultCategory: SUPPORT_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_SUPPORT_SPACE_COLORS][3] ||
      projectColors[SUPPORT_SPACES_CATEGORY],
  },
  [SUPPORT_SPACES.IT_STORAGE_ROOM]: {
    title: 'IT Storage Room',
    defaultCategory: SUPPORT_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_SUPPORT_SPACE_COLORS][4] ||
      projectColors[SUPPORT_SPACES_CATEGORY],
  },
  [SUPPORT_SPACES.IT_TECH_BAR]: {
    title: 'IT Tech Bar',
    defaultCategory: SUPPORT_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_SUPPORT_SPACE_COLORS][5] ||
      projectColors[SUPPORT_SPACES_CATEGORY],
  },
  [SUPPORT_SPACES.JANITORIAL_CLOSET]: {
    title: 'Janitorial Closet',
    defaultCategory: SUPPORT_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_SUPPORT_SPACE_COLORS][6] ||
      projectColors[SUPPORT_SPACES_CATEGORY],
  },
  [SUPPORT_SPACES.MDF]: {
    title: 'MDF',
    defaultCategory: SUPPORT_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_SUPPORT_SPACE_COLORS][7] ||
      projectColors[SUPPORT_SPACES_CATEGORY],
  },
  [SUPPORT_SPACES.RECEPTION_DESK_SEATING]: {
    title: 'Reception Desk & Seating',
    defaultCategory: SUPPORT_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_SUPPORT_SPACE_COLORS][8] ||
      projectColors[SUPPORT_SPACES_CATEGORY],
  },
  [SUPPORT_SPACES.SATELLITE_COPY_AREA]: {
    title: 'Satellite Copy Area',
    defaultCategory: SUPPORT_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_SUPPORT_SPACE_COLORS][9] ||
      projectColors[SUPPORT_SPACES_CATEGORY],
  },
  [SUPPORT_SPACES.STORAGE_ROOM]: {
    title: 'Storage Room',
    defaultCategory: SUPPORT_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_SUPPORT_SPACE_COLORS][10] ||
      projectColors[SUPPORT_SPACES_CATEGORY],
  },
  [SUPPORT_SPACES.FILE_CABINET]: {
    title: 'File Cabinets',
    defaultCategory: SUPPORT_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_SUPPORT_SPACE_COLORS][12] ||
      projectColors[SUPPORT_SPACES_CATEGORY],
  },
  [SUPPORT_SPACES.STORAGE_LOCKER]: {
    title: 'Lockers',
    defaultCategory: SUPPORT_SPACES_CATEGORY,
    color:
      projectColors[CUSTOM_SUPPORT_SPACE_COLORS][13] ||
      projectColors[SUPPORT_SPACES_CATEGORY],
  },
});
